<div class="v2-container">
  <div class="menu-container">
    <app-header></app-header>
    @if (menuConfig$ | async; as menuConfig) {
      <app-menu
        [menuConfig]="menuConfig"
      ></app-menu>
    }
  </div>
  <div #scrollContainer class="content">
    <router-outlet></router-outlet>
  </div>
</div>
